import { useState } from 'react';
import { BreakpointsValuesEnum } from '../constants/breakpoints-values';
import { debounce } from 'lodash';
import { useDidMount } from './useDidMount';

export type Breakpoints = keyof typeof BreakpointsValuesEnum;
const getBreakpoint = (): keyof typeof BreakpointsValuesEnum => {
  const documentWidth = document.body.offsetWidth;

  let breakpoint: Breakpoints | null = 'small';

  if (documentWidth < BreakpointsValuesEnum.medium) {
    breakpoint = 'small';
  } else if (documentWidth >= BreakpointsValuesEnum.medium && documentWidth < BreakpointsValuesEnum.tabletportrait) {
    breakpoint = 'medium';
  } else if (documentWidth >= BreakpointsValuesEnum.tabletportrait && documentWidth < BreakpointsValuesEnum.large) {
    breakpoint = 'tabletportrait';
  } else if (documentWidth >= BreakpointsValuesEnum.large && documentWidth < BreakpointsValuesEnum.xlarge) {
    breakpoint = 'large';
  } else if (documentWidth >= BreakpointsValuesEnum.xlarge && documentWidth < BreakpointsValuesEnum.xxlarge) {
    breakpoint = 'xlarge';
  } else if (documentWidth >= BreakpointsValuesEnum.xxlarge) {
    breakpoint = 'xxlarge';
  }

  return breakpoint;
};

export const useBreakpoints = (): Breakpoints => {
  const [breakpoint, setBreakpoint] = useState<Breakpoints>(getBreakpoint());

  const handleResize = debounce(() => {
    setBreakpoint(getBreakpoint());
  }, 75);

  useDidMount(() => {
    setBreakpoint(getBreakpoint());

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return breakpoint;
};
